import type { SearchTab } from '@citibox-panel/lockers-care';

// Which side of the counter a delivery's «Acciones» card opens on. Named here, in the host, because
// this is a translation between two vocabularies neither module owns alone: the shell knows about
// TABS and `delivery-detail` knows about AUDIENCES, and only the host knows both.
//
// The rule in one sentence: **a delivery opens on the audience of the door the agent came through.**
// A phone search is a recipient's case; a building, a tracking and a loose delivery all arrive from
// the courier's side.
//
// `origin` is read BEFORE `kind`, and one case forces that order: under the titular's branch a
// tracking search produces a `kind: 'user'` tab, byte-for-byte indistinguishable from a phone
// search. So the kind cannot answer it and the ACTIVE sub-tab has to — which also means a «Usuario»
// with one delivery opened by phone and another by tracking gets the right audience on each.
export function defaultAudience(search: SearchTab): 'user' | 'courier' {
  const active = search.deliveries.find((delivery) => delivery.id === search.activeSubtab);
  if (active?.origin === 'tracking') return 'courier';
  return search.kind === 'user' ? 'user' : 'courier';
}
